<ng-container class="row" *ngIf="timePicker; else elseBlock">
	<div class="input-group timepicker" [id]="timePicker.timeID">
		<input class="form-control m-input" [id]="timePicker.timeID" [readOnly]="timePicker.readonly" [placeholder]="timePicker.placeholder" #pickTime
		 [disabled]="timePicker.disabled" [required]="timePicker.required" type="text" (blur)="onTimeChange()">
		<div class="input-group-append">
			<span class="input-group-text">
				<i class="la la-clock-o"></i>
			</span>
		</div>
	</div>
</ng-container>
<ng-template #elseBlock>
	<div class="row">
		<div class="col-4" style="text-align: right">
			<label class="col-form-label">{{label}}</label>
		</div>
		<div class="col-lg-6 col-md-6 col-sm-12">
			<div class="row">
				<div class="form-group m-form__group col-lg-6 col-md-6 col-sm-12">
					<div>
						<div class="input-group timepicker">
							<input class="form-control m-input" (ngModelChange)="emitDateValues()" (blur)="dates.startTime=startTime.value; emitDateValues();"
							 id="m_timepicker_1_modal" [readOnly]="model.readonly" [(ngModel)]="dates.startTime" [placeholder]="model.placeholder1"
							 [disabled]="model.disabled" [required]="model.required" type="text" #startTime>
							<div class="input-group-append">
								<span class="input-group-text">
									<i class="la la-clock-o"></i>
								</span>
							</div>
						</div>
					</div>
				</div>

				<div class="form-group m-form__group col-lg-6 col-md-6 col-sm-12">
					<div>
						<div class="input-group timepicker">
							<input class="form-control m-input" (ngModelChange)="emitDateValues()" (blur)="dates.endTime=endTime.value; emitDateValues();"
							 id="m_timepicker_1" [readOnly]="model.readonly" [(ngModel)]="dates.endTime" [placeholder]="model.placeholder2"
							 [disabled]="model.disabled" [required]="model.required" type="text" #endTime>
							<div class="input-group-append">
								<span class="input-group-text">
									<i class="la la-clock-o"></i>
								</span>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div *ngIf="showErrorMsg" class="red">
				Please Select Date
			</div>
		</div>
	</div>
</ng-template>

<!-- <div>
		<ngb-timepicker [(ngModel)]="time" (ngModelChange)="onNgbTimeChange($event)" [meridian]="meridian"></ngb-timepicker>
</div> -->
